export const capitalize = string =>
  string
    .split(' ')
    .map(x => {
      const [firstChar, ...rest] = x.split('');

      return [firstChar.toUpperCase(), ...rest].join('');
    })
    .join(' ');
